<template>
  <v-container fluid :class="{ 'mt-4': !$vuetify.breakpoint.mobile }">
    <p :class="{'ml-1': $vuetify.breakpoint.mobile}">{{ $t('docs.pageText') }}</p>
    <v-row>
      <v-col cols="12">
        <div v-html="documentContent"></div>

        <mobile-data-list
          v-if="$vuetify.breakpoint.mobile"
          :items="list"
          :loading="loading"
          :items-per-page="10"
          :footer-props="footerProps"
          :hide-default-footer="!authenticated"
          item-key="_key"
          :headers="mobileHeaders"
          single-expand
        >
          <template #item-icon="{ item }">
            <v-icon color="primary">{{ doctypeIcon(item.doctype) }}</v-icon>
          </template>
          <template #item.docname="{ item }">{{ item.docname[lang] }}</template>
          <template #item.date="{ item }">{{ item.date }}</template>
          <template #item.description="{ item }">{{ item.description[lang] }}</template>
          <template #expanded-actions="{ item }">
            <div class="mt-2 mb-1">
              <v-btn small outlined @click.stop="openDocument(item)">
                <v-icon left small>mdi-tray-arrow-down</v-icon>
                {{ $t('claimforms.menu.download') }}
              </v-btn>
            </div>
          </template>
        </mobile-data-list>

        <data-table-scroll-hint v-else>
        <v-data-table
          class="no-select-table documents-table"
          :headers="headers"
          :items="list"
          :loading="loading"
          :items-per-page="10"
          :footer-props="footerProps"
          :hide-default-footer="!authenticated"
          @click:row="openDocument"
        >
          <template v-slot:item.icon="{ item }">
            <v-icon color="primary">{{ doctypeIcon(item.doctype) }}</v-icon>
          </template>
          <template v-slot:item.docname="{ item }">
            {{ item.docname[lang] }}
          </template>
          <template v-slot:item.description="{ item }">
            {{ item.description[lang] }}
          </template>
        </v-data-table>
        </data-table-scroll-hint>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import downloadFile from "@/utils/downloadFile";
import { mapGetters } from "vuex";
import MobileDataList from "@/components/common/MobileDataList";
import DataTableScrollHint from '@/components/common/DataTableScrollHint.vue';

export default {
  name: "Documents",
  components: { MobileDataList, DataTableScrollHint },

  data() {
    return {
      contentLocale: '',
      loading: true,
      list: [],
      meta: null,
    };
  },

  watch: {
    locale() {
      this.$store.dispatch('app/loadDocumentContent', this.locale)
      this.contentLocale = this.locale
    },
  },

  computed: {
    ...mapGetters('app', ['documentContent', 'locale', 'isAuthenticated']),
    footerProps() {
      return { itemsPerPageOptions: this.$vuetify.breakpoint.mobile ? [] : [10, 25, 50] }
    },
    authenticated() {
      return this.isAuthenticated;
    },
    lang() {
      return ((s) => s.replace(s[0], s[0].toUpperCase()))(this.$i18n.locale);
    },
    headingLabel() {
      if (!this.meta) return {};
      return this.meta.headings.reduce((acc, h) => {
        const [key, val] = Object.entries(h)[0];
        acc[key] = val.label[this.lang];
        return acc;
      }, {});
    },
    headers() {
      const l = this.headingLabel;
      return [
        { text: '', value: 'icon', sortable: false, width: '48px' },
        { text: l.docname || 'Namn', value: 'docname', sortable: false },
        { text: l.description || 'Beskrivning', value: 'description', sortable: false },
        { text: l.date || 'Tillagd', value: 'date', sortable: false, width: '140px' },
      ];
    },
    mobileHeaders() {
      const l = this.headingLabel;
      return [
        { value: 'docname',     text: l.docname     || 'Namn',        mobile: 'primary',   sortable: false },
        { value: 'date',        text: l.date        || 'Tillagd',     mobile: 'secondary', sortable: false },
        { value: 'description', text: l.description || 'Beskrivning',                      sortable: false },
      ];
    },
  },
  methods: {
    doctypeIcon(doctype) {
      if (doctype === 'application/pdf') return 'mdi-file-pdf-box';
      if (doctype && doctype.includes('excel')) return 'mdi-file-excel';
      return 'mdi-file-document';
    },
    loadDocs() {
      this.loading = true;
      this.$store.dispatch('app/loadDocuments')
        .then((data) => {
          this.list = data.rows.map((row, i) => ({ ...row, _key: i }));
          this.meta = data.meta;
          this.loading = false;
        })
    },

    openDocument(doc) {
      const uri = doc.docuri[this.lang];
      this.$store.dispatch('app/downloadDocument', {uri, type: doc.doctype})
        .then((uri) => {
          downloadFile(doc.docname[this.lang], uri);
        });

    }
  },
  mounted() {
    if (!this.documentContent || this.locale!==this.contentLocale) {
      this.$store.dispatch('app/loadDocumentContent', this.locale)
      this.contentLocale = this.locale
    }
    this.loadDocs();
  }
}
</script>

<style>
</style>